import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  useTheme
} from "@mui/material";
import { useNavigate } from "react-router";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Success = () => {
  const [open] = React.useState(true);
  const theme = useTheme();
  const navigate = useNavigate();

  const handleGoToDashboard = () => navigate("/");

  return (
    <Modal
      open={open}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#D6B981"
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 500,
          bgcolor: "#F0EAD6",
          borderRadius: theme.shape.borderRadius,
          p: theme.spacing(4),
          outline: "none",
          textAlign: "center"
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 3,
            color: theme.palette.success.main
          }}
        >
          <CheckCircleOutlineIcon sx={{ color: "#D6B981", fontSize: 64 }} />
        </Box>

        <Typography
          id="success-modal-title"
          variant="h5"
          component="h2"
          sx={{ 
            mb: 2,
            fontWeight: 700,
            color: "#D6B981"
          }}
        >
          Erfolgreich abgeschlossen
        </Typography>
        <Typography
            variant="body1"
            sx={{ 
            mb: 4,
            color: theme.palette.text.secondary,
            fontSize: "1rem"
            }}
        >
           Der Vorgang wurde erfolgreich beendet. Kehren Sie zum Dashboard zurück, um bei Bedarf einen neuen Prozess zu starten.
        </Typography>


        <Button
          variant="contained"
          onClick={handleGoToDashboard}
          size="large"
          fullWidth
          sx={{
            backgroundColor: "#D6B981",
            py: 1.8,
            fontSize: "1.1rem",
            fontWeight: 600,
            
            "&:hover": {
              backgroundColor: "#D6B981",
              opacity: 0.9
            }
          }}
        >
          Zum Dashboard zurückkehren
        </Button>
      </Box>
    </Modal>
  );
};

export default Success;
